import {Routes} from '@angular/router';
import {AppLayout} from '@/layout/components/app.layout';
import {LandingLayout} from '@/layout/components/app.landinglayout';
import {AuthLayout} from '@/layout/components/app.authlayout';
import {Notfound} from '@/pages/notfound/notfound';
import {AuthGuard} from '@/core/guards/auth.guard';
import {RoleGuard} from '@/core/guards/role.guard';
import {PublicGuard} from '@/core/guards/public.guard';
import {MfaGuard} from '@/core/guards/mfa.guard';

export const appRoutes: Routes = [
    {
        path: '',
        component: AppLayout,
        canActivate: [AuthGuard, RoleGuard],
        canActivateChild: [RoleGuard],
        children: [
            {
                path: '',
                loadComponent: () => import('@/pages/dashboards/marketing/marketingdashboard').then((c) => c.MarketingDashboard),
                data: {breadcrumb: 'Marketing Dashboard'}
            },
            {
                path: 'dashboard-ecommerce',
                loadComponent: () => import('@/pages/dashboards/ecommerce/ecommercedashboard').then((c) => c.EcommerceDashboard),
                data: {breadcrumb: 'E-Commerce Dashboard'}
            },
            {
                path: 'dashboard-banking',
                loadComponent: () => import('@/pages/dashboards/banking/bankingdashboard').then((c) => c.BankingDashboard),
                data: {breadcrumb: 'Banking Dashboard'}
            },
            {
                path: 'uikit',
                data: {breadcrumb: 'UI Kit'},
                loadChildren: () => import('@/pages/uikit/uikit.routes')
            },
            {
                path: 'documentation',
                data: {breadcrumb: 'Documentation'},
                loadComponent: () => import('@/pages/documentation/documentation').then((c) => c.Documentation)
            },
            {
                path: 'pages',
                loadChildren: () => import('@/pages/pages.routes'),
                data: {breadcrumb: 'Pages'}
            },
            {
                path: 'apps',
                loadChildren: () => import('@/apps/apps.routes'),
                data: {breadcrumb: 'Apps'}
            },

            {
                path: 'blocks',
                data: {breadcrumb: 'Free Blocks'},
                loadChildren: () => import('@/pages/blocks/blocks.routes')
            },
            {
                path: 'ecommerce',
                loadChildren: () => import('@/pages/ecommerce/ecommerce.routes'),
                data: {breadcrumb: 'E-Commerce'}
            },
            {
                // Antes cargaba el demo `usermanagement` de la plantilla (lista/alta de usuarios ficticios),
                // al que no llegaba ningún enlace de la app. Ahora es el perfil real del usuario logueado,
                // que es a donde apunta el menú del avatar en el topbar.
                path: 'profile',
                loadComponent: () => import('@/pages/profile/profile.component').then((c) => c.ProfileComponent),
                data: {breadcrumb: 'Mi perfil'}
            }
        ]
    },
    {
        path: 'landing',
        component: LandingLayout,
        children: [
            {
                path: '',
                loadComponent: () => import('@/pages/landing').then((c) => c.Landing)
            },
            {
                path: 'about',
                loadComponent: () => import('@/pages/landing/about').then((c) => c.About)
            },
            {
                path: 'pricing',
                loadComponent: () => import('@/pages/landing/pricing').then((c) => c.Pricing)
            },
            {
                path: 'contact',
                loadComponent: () => import('@/pages/landing/contact').then((c) => c.Contact)
            },
            {
                path: 'login',
                canActivate: [PublicGuard],
                loadComponent: () => import('@/pages/auth/login/login.component').then((c) => c.Login)
            },
            // {
            //     path: 'register',
            //     canActivate: [PublicGuard],
            //     loadComponent: () => import('@/pages/auth/register').then((c) => c.Register)
            // },
            {
                path: 'verification',
                canActivate: [MfaGuard],
                loadComponent: () => import('@/pages/auth/verification').then((c) => c.Verification)
            },
            {
                path: 'forgot-password',
                canActivate: [PublicGuard],
                loadComponent: () => import('@/pages/auth/forgotpassword/forgotpassword.component').then((c) => c.ForgotPassword)
            },
            {
                path: 'reset-password',
                canActivate: [PublicGuard],
                loadComponent: () => import('@/pages/auth/resetpassword/resetpassword.component').then((c) => c.ResetPassword)
            },
            {
                path: 'new-password',
                canActivate: [PublicGuard],
                loadComponent: () => import('@/pages/auth/newpassword').then((c) => c.NewPassword)
            },
            {
                path: 'lock-screen',
                canActivate: [PublicGuard],
                loadComponent: () => import('@/pages/auth/lockscreen').then((c) => c.LockScreen)
            },
            {
                path: 'oops',
                loadComponent: () => import('@/pages/oops/oops').then((c) => c.Oops)
            },
            {
                path: 'access',
                loadComponent: () => import('@/pages/landing/access').then((c) => c.AccessDeniedComponent)
            },
            {
                path: 'error',
                redirectTo: '/notfound'
            }
        ]
    },
    {
        path: 'buzon',
        component: LandingLayout,
        children: [
            {
                path: '',
                loadComponent: () => import('@/pages/landing/buzon-anonimo').then((c) => c.BuzonAnonimo)
            }
        ]
    },
    {path: 'notfound', component: Notfound},
    {
        path: 'auth',
        component: AuthLayout,
        children: []
    },
    {path: '**', redirectTo: ''}
];
